module.exports = __webpack_public_path__ + "static/images/components/Gamefield/images/gamefield-50.d23908e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/Gamefield/images/gamefield-50.jpg
// module id = 2598
// module chunks = 11